module.exports = __webpack_public_path__ + "media/images/support/geolocation/geolocation-osx-permission-1-0ad2aeb424297782c70bc758dc925447.png";